export type FaqItem = {
  question: string;
  answer: string;
};

const ITEM_SEPARATOR = /<br\s*\/?>\s*<br\s*\/?>/i;
const LINE_SEPARATOR = /<br\s*\/?>/i;
const LABEL_PREFIX = /^[^:\s]+:\s/;

export const parseFaqItems = (raw: unknown): FaqItem[] => {
  if (typeof raw !== "string" || !raw.trim()) return [];

  return raw
    .split(ITEM_SEPARATOR)
    .map((block) => block.trim())
    .filter(Boolean)
    .flatMap((block) => {
      const separator = LINE_SEPARATOR.exec(block);
      if (!separator) return [];

      const question = block
        .slice(0, separator.index)
        .replace(LABEL_PREFIX, "")
        .trim();
      const answer = block
        .slice(separator.index + separator[0].length)
        .replace(LABEL_PREFIX, "")
        .trim();

      if (!question || !answer) return [];
      return [{ question, answer }];
    });
};
